import { Phone } from "lucide-react";
import { COMPANY } from "@/lib/data";

export default function StickyCall() {
  return (
    <a
      href={`tel:${COMPANY.phoneRaw}`}
      data-testid="sticky-call-cta"
      className="md:hidden fixed bottom-4 right-4 z-40 bg-teal-500 text-white rounded-full shadow-2xl shadow-teal-500/40 px-5 py-3.5 flex items-center gap-2 font-semibold animate-fade-in"
      aria-label="Call Comfort Care Transportation"
    >
      <Phone className="w-4 h-4" /> Call Now
    </a>
  );
}
